import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class SalarySettingList extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			dept : '',
			depart : [],
			accyear : [],
			emp : [],
			payhe : [],
			desig : '',
			employee : '',
			payhead : '',
			unit : '',
			ptype : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			 posts: [],
			 salary : []
		}
		this.onChange = this.onChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	onClick(e){
		
		document.getElementById("salform").reset();
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/addsalarysetting',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.state = {payhead : '',
					unit : '',};
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
		// alert('id '+id+'pay '+payhead+' val '+e.target.value);
		console.log(this.state.salary);
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('payroll/deletesalset',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Salary Settings Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Salary Settings',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		this.getdata();
		this.getemployee();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		$("#showLoader").show();
		GetData('employee/getemployee').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					emp : responseJson
				});
			}
		});
	}
	
	getdata(){
		// var emp = $("#employ").val();
		$("#showLoader").show();
		GetData('payroll/getsalsetting').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	getsalary(empid){
		
		var pay = [];
		
		if(this.getsalamt(empid)!=false){
			
			pay.push(<td>{this.getsalamt(empid)}</td>);
		}
		else{
			
			pay.push(<td></td>);
		}
		
		return pay;
	}
	
	getsalamt(emp){
		
		var bstate=false;
		
		for(var j=0;j<this.state.posts.length;j++){
			
			if(this.state.posts[j].employee == emp && this.state.posts[j].payhead == 1){
				
				bstate = this.state.posts[j].amount;
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	getbasic(empid){
		
		var pay = [];
		
		if(this.getbasicamt(empid)!=false){
			
			pay.push(<td>{this.getbasicamt(empid)}</td>);
		}
		else{
			
			pay.push(<td></td>);
		}
		
		return pay;
	}
	
	getbasicamt(emp){
		
		var bstate=false;
		
		for(var j=0;j<this.state.posts.length;j++){
			
			if(this.state.posts[j].employee == emp && this.state.posts[j].payhead == 1){
				
				var salary = this.state.posts[j].amount;
				bstate = salary * 92/100;
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	gethra(empid){
		
		var pay = [];
		
		if(this.gethraamt(empid)!=false){
			
			pay.push(<td>{this.gethraamt(empid)}</td>);
		}
		else{
			
			pay.push(<td></td>);
		}
		
		return pay;
	}
	
	gethraamt(emp){
		
		var bstate=false;
		
		for(var j=0;j<this.state.posts.length;j++){
			
			if(this.state.posts[j].employee == emp && this.state.posts[j].payhead == 1){
				
				var salary = this.state.posts[j].amount;
				bstate = salary * 5/100;
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	getta(empid){
		
		var pay = [];
		
		if(this.gettaamt(empid)!=false){
			
			pay.push(<td>{this.gettaamt(empid)}</td>);
		}
		else{
			
			pay.push(<td></td>);
		}
		
		return pay;
	}
	
	gettaamt(emp){
		
		var bstate=false;
		
		for(var j=0;j<this.state.posts.length;j++){
			
			if(this.state.posts[j].employee == emp && this.state.posts[j].payhead == 1){
				
				var salary = this.state.posts[j].amount;
				bstate = salary * 3/100;
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	getpf(empid){
		
		var pay = [];
		
		if(this.getpfamt(empid)!=false){
			
			pay.push(<td>{this.getpfamt(empid)}</td>);
		}
		else{
			
			pay.push(<td></td>);
		}
		
		return pay;
	}
	
	getpfamt(emp){
		
		var bstate=false;
		
		for(var j=0;j<this.state.posts.length;j++){
			
			if(this.state.posts[j].employee == emp && this.state.posts[j].payhead == 2){
				
				bstate = this.state.posts[j].amount;
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	getesi(empid){
		
		var pay = [];
		
		if(this.getesiamt(empid)!=false){
			
			pay.push(<td>{this.getesiamt(empid)}</td>);
		}
		else{
			
			pay.push(<td></td>);
		}
		
		return pay;
	}
	
	getesiamt(emp){
		
		var bstate=false;
		
		for(var j=0;j<this.state.posts.length;j++){
			
			if(this.state.posts[j].employee == emp && this.state.posts[j].payhead == 3){
				
				bstate = this.state.posts[j].amount;
				break;
			}
			else{
				
				bstate = false;
			}
		}
		
		return bstate;
	}
	
	getnetsal(empid){
		
		var pay = [];
		
		var sal = this.getsalamt(empid);
		var pf = this.getpfamt(empid);
		var esi = this.getesiamt(empid);
		
		if(sal!=false){
			
			pay.push(<td>{(sal)-(pf)-(esi)}</td>);
		}
		else{
			
			pay.push(<td></td>);
		}
		
		return pay;
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/employee/payroll/editsalarysetting/' + this.state.idd} />);

	}
	
	var acyear = this.state.accyear;
	
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="salform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Salary Setting List</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						Academic Year : &nbsp;&nbsp;
						<select name="acyear" onChange={this.onChange} required id="year">
							<option value="">Select Academic Year</option>
							{
								acyear.map(function (item) {
									return <option value={item.id }>{item.value}</option>;
								})
							}
						</select>
					</CardHeader>
					<CardBody>
					 <Row>
					  <Col md="12">
						<Table responsive bordered  id="atttable">
						  <thead>
							<tr>
								<th>S.No</th>
								<th>Staff Name</th>
								<th>Salary</th>
								<th>Basic</th>
								<th>HRA</th>
								<th>TA</th>
								<th>PF</th>
								<th>ESI</th>
								<th>Net Salary</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.emp.map((item,i) =>
						 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>{item.empname}</td>
									{this.getsalary(item.id)}
									{this.getbasic(item.id)}
									{this.gethra(item.id)}
									{this.getta(item.id)}
									{this.getpf(item.id)}
									{this.getesi(item.id)}
									{this.getnetsal(item.id)}
								</tr>
							)}
						  </tbody>
						</Table>
					  </Col>
					 </Row>
					</CardBody>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default SalarySettingList;


// WEBPACK FOOTER //
// ./src/payroll/SalarySettings/SalarySettingList.js